import React from 'react';

const CRA = () => {
    return null;
}

export default CRA;